// Primero: Zod sin su prueba de `eval` (P-114). Tiene que ir antes que la app.
import './lib/sin-eval.js';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { registerServiceWorker } from './lib/pwa.js';
import './styles/globals.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('No se encontró el nodo #root: el index.html no es el esperado.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

void registerServiceWorker({ isProduction: import.meta.env.PROD });
